var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useMemo, useState } from "react";
import { SaveButton, SelectInput, SimpleForm, TextInput, Toolbar, required, useNotify, useUpdate, } from "react-admin";
import { useWatch } from "react-hook-form";
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { EMobileCandidateLists } from "@sequentech/ui-core";
import { ElectionStyles } from "@/components/styles/ElectionStyles";
import { adminTheme } from "@sequentech/ui-essentials";
import { SLATES_VERSION, checkSlatesConfiguration, putSlate, slateCandidateChoices, slateFormValues, slateFromForm, slatesProblemsFromError, writeSlatesConfig, } from "@/utils/slates";
var ContestMembersRow = function (_a) {
    var _b;
    var contest = _a.contest, contestName = _a.contestName, candidates = _a.candidates, config = _a.config, slateId = _a.slateId, disabled = _a.disabled;
    var t = useTranslation().t;
    var source = "members.".concat(contest.id);
    var chosen = (_b = useWatch({ name: source })) !== null && _b !== void 0 ? _b : [];
    var offered = slateCandidateChoices(candidates, contest.id, config, slateId);
    return (_jsxs(Box, { component: "tr", sx: { "borderBottom": "1px solid rgba(0, 0, 0, 0.12)", "& > td": { verticalAlign: "top" } }, children: [_jsx(Box, { component: "td", sx: { padding: "24px 16px", width: "240px" }, children: _jsx(Typography, { sx: { fontWeight: 700, color: adminTheme.palette.brandColor }, children: contestName }) }), _jsx(Box, { component: "td", sx: { padding: "16px 0 8px", width: "600px", maxWidth: "100%" }, children: chosen.map(function (candidateId, index) {
                    var pickedElsewhere = new Set(chosen.filter(function (other, position) { return position !== index && other; }));
                    var current = candidates.find(function (_a) {
                        var id = _a.id;
                        return id === candidateId;
                    });
                    var choices = offered.filter(function (_a) {
                        var id = _a.id;
                        return !pickedElsewhere.has(id);
                    });
                    if (current && !choices.some(function (_a) {
                        var id = _a.id;
                        return id === current.id;
                    })) {
                        choices.push(current);
                    }
                    return (_jsx(SelectInput, { source: "".concat(source, ".").concat(index), label: String(t("slateScreen.members.candidate")), choices: choices.map(function (_a) {
                            var id = _a.id, label = _a.label;
                            return ({ id: id, name: label });
                        }), emptyValue: "", emptyText: String(t("slateScreen.members.noCandidate")), disabled: disabled, fullWidth: true, helperText: false }, "".concat(contest.id, "-").concat(index)));
                }) })] }));
};
var SlateSection;
(function (SlateSection) {
    SlateSection["GENERAL"] = "general";
    SlateSection["MEMBERS"] = "members";
})(SlateSection || (SlateSection = {}));
export var SlateDataForm = function (_a) {
    var election = _a.election, slateId = _a.slateId, slate = _a.slate, config = _a.config, contests = _a.contests, contestName = _a.contestName, candidates = _a.candidates, candidateOptions = _a.candidateOptions, defaultLanguage = _a.defaultLanguage, canEdit = _a.canEdit, onSaved = _a.onSaved;
    var t = useTranslation().t;
    var notify = useNotify();
    var update = useUpdate()[0];
    var _b = useState([]), problems = _b[0], setProblems = _b[1];
    var _c = useState([]), collapsed = _c[0], setCollapsed = _c[1];
    var record = useMemo(function () { return (__assign({ id: slateId }, slateFormValues(slate, contests, defaultLanguage))); }, [slateId, slate, contests, defaultLanguage]);
    var toggleSection = function (section) {
        return setCollapsed(function (current) {
            return current.includes(section)
                ? current.filter(function (other) { return other !== section; })
                : __spreadArray(__spreadArray([], current, true), [section], false);
        });
    };
    var save = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var edited, next, found, error_1, thrown;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    edited = slateFromForm(slateId, values, defaultLanguage, slate);
                    next = putSlate(config !== null && config !== void 0 ? config : {
                        version: SLATES_VERSION,
                        mobile_candidate_lists: EMobileCandidateLists.COLLAPSED,
                        slates: [],
                    }, edited);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    found = checkSlatesConfiguration(JSON.stringify(next), defaultLanguage, contests, candidates);
                    if (found.length > 0) {
                        setProblems(found.map(function (_a) {
                            var message = _a.message;
                            return message;
                        }));
                        notify(t("slateScreen.messages.invalid"), { type: "error" });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, update("sequent_backend_election", {
                            id: election.id,
                            data: { annotations: writeSlatesConfig(election.annotations, next) },
                            previousData: election,
                        }, { mutationMode: "pessimistic", returnPromise: true })];
                case 2:
                    _a.sent();
                    setProblems([]);
                    notify(t("slateScreen.messages.saved"), { type: "success" });
                    onSaved(edited.id);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    thrown = slatesProblemsFromError(error_1);
                    setProblems(thrown
                        ? thrown.map(function (_a) {
                            var message = _a.message;
                            return message;
                        })
                        : [error_1 instanceof Error ? error_1.message : String(error_1)]);
                    notify(t("slateScreen.messages.error"), { type: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var sectionSummary = function (section, title) { return (_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "slate-data-".concat(section) }), children: _jsx(ElectionStyles.Wrapper, { children: _jsx(ElectionStyles.Title, { children: title }) }) })); };
    return (_jsxs(SimpleForm, { record: record, onSubmit: save, toolbar: _jsx(Toolbar, { children: canEdit && _jsx(SaveButton, {}) }), children: [_jsxs(Accordion, { sx: { width: "100%" }, expanded: !collapsed.includes(SlateSection.GENERAL), onChange: function () { return toggleSection(SlateSection.GENERAL); }, children: [sectionSummary(SlateSection.GENERAL, t("slateScreen.edit.general")), _jsxs(AccordionDetails, { children: [_jsx(TextInput, { source: "name", helperText: false, label: String(t("slateScreen.field.name")), validate: required(), disabled: !canEdit }), _jsx(TextInput, { source: "alias", helperText: false, label: String(t("slateScreen.field.alias")), disabled: !canEdit }), _jsx(TextInput, { source: "description", helperText: false, label: String(t("slateScreen.field.description")), multiline: true, disabled: !canEdit }), _jsx(TextInput, { source: "external_id", helperText: false, label: String(t("slateScreen.field.externalId")), disabled: !canEdit })] })] }), _jsxs(Accordion, { sx: { width: "100%" }, expanded: !collapsed.includes(SlateSection.MEMBERS), onChange: function () { return toggleSection(SlateSection.MEMBERS); }, children: [sectionSummary(SlateSection.MEMBERS, t("slateScreen.edit.members")), _jsxs(AccordionDetails, { children: [_jsx(Typography, { variant: "body2", sx: { color: "text.secondary", fontSize: "12px", marginBottom: "16px" }, children: t("slateScreen.members.helper") }), _jsx(Box, { sx: { overflowX: "auto", width: "100%" }, children: _jsxs(Box, { component: "table", sx: {
                                        "borderCollapse": "collapse",
                                        "width": "100%",
                                        "maxWidth": "900px",
                                        "& th": {
                                            textAlign: "left",
                                            padding: "8px 16px 16px",
                                            fontWeight: 700,
                                            fontSize: "14px",
                                        },
                                    }, children: [_jsx("thead", { children: _jsxs(Box, { component: "tr", sx: { borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }, children: [_jsx("th", { children: t("slateScreen.members.contest") }), _jsx(Box, { component: "th", sx: { paddingLeft: "0 !important" }, children: t("slateScreen.members.candidate") })] }) }), _jsx("tbody", { children: contests.map(function (contest) { return (_jsx(ContestMembersRow, { contest: contest, contestName: contestName(contest), candidates: candidateOptions, config: config, slateId: slateId, disabled: !canEdit }, contest.id)); }) })] }) })] })] }), problems.length > 0 && (_jsx(Alert, { severity: "error", sx: { width: "100%", marginTop: "1rem" }, children: _jsx(Box, { component: "ul", sx: { margin: 0, paddingLeft: "1rem" }, children: problems.map(function (message) { return (_jsx("li", { children: message }, message)); }) }) }))] }, slateId));
};
